import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "px-5 pb-5 container" }
const _hoisted_2 = { class: "header d-flex justify-content-between align-itens-center col" }
const _hoisted_3 = { class: "m-0" }
const _hoisted_4 = { class: "container-form mb-4" }
const _hoisted_5 = { class: "form d-flex flex-wrap" }
const _hoisted_6 = { class: "row w-100 mb-3 d-flex align-items-center justify-content-between" }
const _hoisted_7 = { class: "form-group mb-3" }
const _hoisted_8 = { for: "name" }
const _hoisted_9 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_10 = { class: "form-group mb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "cpf" }, "CPF", -1)
const _hoisted_12 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_13 = { class: "form-group mb-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "E-mail", -1)
const _hoisted_15 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_16 = { class: "row w-100 mb-3 d-flex align-items-center justify-content-start" }
const _hoisted_17 = { class: "form-group mb-3 me-5" }
const _hoisted_18 = { for: "phone" }
const _hoisted_19 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_20 = { class: "form-group mb-3 ms-3" }
const _hoisted_21 = { for: "typeUser" }
const _hoisted_22 = {
  key: 0,
  class: "text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_ds_button = _resolveComponent("ds-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.userId ? _ctx.$t("user.edit") : _ctx.$t("user.register")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("form", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("user.fields.name")), 1),
            _createVNode(_component_InputText, {
              id: "name",
              name: "name",
              type: "text",
              class: _normalizeClass(["form-control", `w-100 ${_ctx.v$.form.user.name.$error ? 'p-invalid' : ''}`]),
              placeholder: _ctx.$t('user.fields.fullName'),
              modelValue: _ctx.form.user.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.user.name) = $event)),
              required: ""
            }, null, 8, ["placeholder", "modelValue", "class"]),
            (_ctx.v$.form.user.name.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_9, _toDisplayString(_ctx.$t("utils.mandatory")), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_InputMask, {
              id: "cpf",
              name: "cpf",
              type: "text",
              class: _normalizeClass(["form-control", `w-100 ${_ctx.v$.form.user.cpf.$error ? 'p-invalid' : ''}`]),
              mask: "999.999.999-99",
              placeholder: "000.000.000-00",
              modelValue: _ctx.form.user.cpf,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.user.cpf) = $event)),
              required: "",
              disabled: _ctx.userId ? true : false
            }, null, 8, ["modelValue", "class", "disabled"]),
            (_ctx.v$.form.user.cpf.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_12, _toDisplayString(_ctx.$t("utils.mandatory")), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_InputText, {
              id: "email",
              name: "email",
              type: "text",
              class: _normalizeClass(["form-control", `w-100 ${_ctx.v$.form.user.email.$error ? 'p-invalid' : ''}`]),
              placeholder: "user@email.com",
              modelValue: _ctx.form.user.email,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.user.email) = $event)),
              required: "",
              disabled: _ctx.userId ? true : false
            }, null, 8, ["modelValue", "class", "disabled"]),
            (_ctx.v$.form.user.email.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_15, _toDisplayString(_ctx.$t("utils.mandatory")), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("user.fields.phone")), 1),
            _createVNode(_component_InputMask, {
              id: "phone",
              name: "phone",
              type: "text",
              class: _normalizeClass(["form-control", `w-100 ${_ctx.v$.form.user.phone.$error ? 'p-invalid' : ''}`]),
              mask: "(99) 99999-9999",
              placeholder: "(00) 00000-0000",
              modelValue: _ctx.form.user.phone,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.user.phone) = $event)),
              required: ""
            }, null, 8, ["modelValue", "class"]),
            (_ctx.v$.form.user.phone.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_19, _toDisplayString(_ctx.$t("utils.mandatory")), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("user.fields.type")), 1),
            _createVNode(_component_Dropdown, {
              id: "typeUser",
              name: "typeUser",
              class: _normalizeClass(["form-control", `w-100 ${
                _ctx.v$.form.user.userType.$error ? 'p-invalid' : ''
              }`]),
              options: _ctx.roles == 'ADMIN' ? _ctx.typerUserForAdmin : _ctx.typeUser,
              optionLabel: "name",
              optionValue: "code",
              placeholder: _ctx.$t('user.fields.selectUserType'),
              modelValue: _ctx.form.user.type,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.user.type) = $event)),
              "aria-required": "true",
              disabled: _ctx.userId ? true : false
            }, {
              option: _withCtx(({ option }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t(option.title_key)), 1)
              ]),
              _: 1
            }, 8, ["options", "placeholder", "modelValue", "class", "disabled"]),
            (_ctx.v$.form.user.userType.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_22, _toDisplayString(_ctx.$t("utils.mandatory")), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(_component_ds_button, {
          type: "secondary",
          text: _ctx.$t('utils.back'),
          class: "float-end me-3",
          onClick: _cache[5] || (_cache[5] = () => _ctx.$router.push({ name: 'Users' }))
        }, null, 8, ["text"]),
        _createVNode(_component_ds_button, {
          type: "primary",
          disabled: _ctx.disabledButton,
          text: _ctx.$t('utils.save'),
          class: "float-end",
          onClick: _ctx.sendUser
        }, null, 8, ["disabled", "text", "onClick"])
      ])
    ])
  ]))
}